"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentFileValidationErrorType = void 0;
var AttachmentFileValidationErrorType;
(function (AttachmentFileValidationErrorType) {
    AttachmentFileValidationErrorType["ValidFileType"] = "validFileType";
    AttachmentFileValidationErrorType["FileSizeTooLarge"] = "fileSizeTooLarge";
})(AttachmentFileValidationErrorType = exports.AttachmentFileValidationErrorType || (exports.AttachmentFileValidationErrorType = {}));
